import { apiPost } from "@/lib/http/client";
import type { WebSession } from "@/lib/auth/session";

/** One in-flight POST /auth/sessions per login_token (React StrictMode-safe). */
const flights = new Map<string, Promise<WebSession>>();

export function redeemLoginToken(loginToken: string): Promise<WebSession> {
  const trimmed = loginToken.trim();
  const existing = flights.get(trimmed);
  if (existing) {
    return existing;
  }

  const flight = apiPost<WebSession>("/auth/sessions", { login_token: trimmed }).finally(() => {
    flights.delete(trimmed);
  });
  flights.set(trimmed, flight);
  return flight;
}
